import { Action } from '@ngrx/store';

export const CLEAR_STORE = '[Applications] Clear Store';

export class ClearStoreAction implements Action {
    readonly type = CLEAR_STORE;
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions = ClearStoreAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/actions/application.actions.ts